import "./home-icon.styles.css";

export default function HomeIcon() {
  return (
    <lord-icon
      class="home-icon"
      src="https://cdn.lordicon.com/gmzxduhd.json"
      trigger="hover"
      colors="primary:#515151,secondary:#a6cdde"
    ></lord-icon>
  );
}
